{
  "title": "Module",
  "installed_count": "{{count}} installiert",
  "loading": "Lade Module…",
  "empty": "Keine Module gefunden.",
  "status": {
    "loaded": "Geladen",
    "error": "Fehler",
    "available": "Verfügbar"
  },
  "update": {
    "available": "Update verfügbar",
    "badge": "v{{from}} → v{{to}}",
    "current": "Aktuell",
    "count_one": "{{count}} Update",
    "count_other": "{{count}} Updates",
    "all": "Alle updaten",
    "all_running": "Aktualisiere ({{done}}/{{total}})…"
  },
  "actions": {
    "install": "Installieren",
    "installing": "Installiert…",
    "update": "Aktualisieren",
    "updating": "Aktualisiert…",
    "uninstall": "Deinstallieren",
    "uninstalling": "Deinstalliert…"
  },
  "log": {
    "waiting": "Warte auf Ausgabe…",
    "success": "Erfolgreich abgeschlossen",
    "failed": "Fehlgeschlagen"
  }
}
